import { ui } from "../../utils/ui";

const showDestinationMap = () => ui.viewMode.map.click();

const showDestinationList = () => ui.viewMode.list.click();

export { showDestinationMap, showDestinationList };
